module.exports = __webpack_public_path__ + "static/media/nav-home-hover.2a18ed6b.svg";